import SV from 'server-vars';
import {
    trackEcommerce,
    trackEvent as trackEventFn,
    trackPageview,
    TrackingObject,
    EcomProduct,
} from 'dibs-tracking';

type pageViewProps = {
    url?: string;
    pageType?: string;
    pageSubType?: string;
};

export const trackPageView = (trackObj: pageViewProps = {}): void => {
    const initialTrackingValues = SV.get('tracking.initialDataLayerInfo') || null;
    const pageView: TrackingObject = {
        url: window.location.href,
        additional: {},
    };
    let hasAdditionalTrackingValues = false;
    if (trackObj) {
        if (trackObj.url) {
            pageView.url = trackObj.url;
        }
        if (trackObj.pageType && trackObj.pageSubType) {
            pageView.additional = {};
            pageView.additional.pageType = trackObj.pageType;
            pageView.additional.pageSubType = trackObj.pageSubType;
            hasAdditionalTrackingValues = true;
        } else {
            hasAdditionalTrackingValues = false;
        }
    }
    if (!hasAdditionalTrackingValues && initialTrackingValues) {
        const additional: TrackingObject['additional'] = {};
        if (initialTrackingValues.pageType) {
            additional.pageType = initialTrackingValues.pageType;
        }
        if (initialTrackingValues.pageSubType) {
            additional.pageSubType = initialTrackingValues.pageSubType;
        }
        if (Object.keys(additional).length) {
            pageView.additional = additional;
        }
    }
    trackPageview(pageView);
};

type trackEventProps = {
    category: string;
    action: string;
    label?: string;
};

export const trackEvent = ({ category, action, label }: trackEventProps): void => {
    let trackObj: TrackingObject = { category, action };
    if (label) {
        trackObj = {
            ...trackObj,
            label,
        };
    }
    trackEventFn(trackObj);
};

type trackEcomArgs = {
    type: 'productImpression' | 'productClick';
    products: EcomProduct[] | EcomProduct;
    actionFieldList?: string;
};

export const trackEcomEvent = ({ type, products, actionFieldList }: trackEcomArgs): void => {
    const trackObj: TrackingObject = {
        products: Array.isArray(products) ? products : [products],
        type,
        actionField: {},
    };
    if (actionFieldList) {
        trackObj.actionField = {
            list: actionFieldList,
        };
        if (type === 'productClick') {
            trackObj.actionField.itemId = Array.isArray(products) ? products?.[0]?.id : products.id;
        }
    }
    trackEcommerce(trackObj);
};
